import type { IGeoJson } from '@/Interfaces/Geo/GeoJson.interface';

export const EMPTY_FEATURE_COLLECTION: IGeoJson = {
  type: 'FeatureCollection',
  features: [],
} as unknown as IGeoJson;

// `getBoundariesRequestBody` returns `undefined` when the underlying report
// has no rows, and `{ mapScale, geoIds: [] }` when every row's id is filtered
// out (empty / 'Unknown'). In both cases the BE GeoBoundariesValidator rejects
// the payload with a 422. Short-circuit to an empty FeatureCollection here so
// the map renders an unfilled basemap (the layer guard in `dataLayerStyle`
// handles that path) instead of the dashboard logging a misleading boundary
// failure for what is just "no data at this scale yet".
export const isPostableBoundariesBody = (
  body: { geoIds?: string[] } | undefined,
): body is { mapScale: string; geoIds: string[] } => Boolean(body?.geoIds?.length);
